import React from "react";
import { Box } from "@bca/ui-library";

const Grade5SVG: React.FunctionComponent = () => (
  <Box display="flex">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#F56600"/>
      <path d="m10.537 12.468-1.572-.376.567-5.045h5.592V8.64h-3.972l-.246 2.208c.132-.078.333-.16.602-.246.269-.092.57-.137.902-.137.483 0 .912.075 1.285.225.374.15.69.37.95.657.265.287.465.638.602 1.052.137.415.205.885.205 1.409 0 .442-.068.863-.205 1.264a3.14 3.14 0 0 1-.622 1.067c-.278.31-.627.553-1.046.731-.42.178-.916.267-1.49.267a4.08 4.08 0 0 1-1.244-.192 3.414 3.414 0 0 1-1.074-.567 2.922 2.922 0 0 1-.758-.91 2.754 2.754 0 0 1-.294-1.23h1.955c.027.283.1.527.219.732.123.2.284.355.485.465.2.109.435.164.704.164.25 0 .465-.048.643-.144.177-.096.32-.228.43-.396.11-.174.19-.374.24-.602.054-.232.082-.483.082-.752a2.61 2.61 0 0 0-.096-.731 1.564 1.564 0 0 0-.294-.568c-.132-.16-.3-.282-.506-.369-.2-.087-.435-.13-.704-.13-.365 0-.647.057-.848.171-.196.114-.36.244-.492.39Z" fill="#fff"/>
    </svg>
  </Box>
);

export default Grade5SVG;
